import {Reducer} from 'redux';
import {persistReducer} from 'redux-persist';
import localStorage from 'redux-persist/lib/storage';
import sessionStorage from 'redux-persist/lib/storage/session';

/**
 * ローカルストレージに保存
 *
 * @param {Reducer} reducer リデューサー
 * @param {string} name ストレージの名前
 * @param {array} blacklist 保存対象外の属性
 * @return {Reducer} 永続保存処理でラップされたリデューサー
 */
export function persistLocal(
    name: string,
    reducer: Reducer,
    blacklist?: string[]
): Reducer {
  const config = {
    key: name,
    storage: localStorage,
    blacklist: blacklist || [],
  };
  return persistReducer(config, reducer);
}

/**
 * セッションストレージに保存
 *
 * @param {Reducer} reducer リデューサー
 * @param {string} name ストレージの名前
 * @param {array} blacklist 保存対象外の属性
 * @return {Reducer} 永続保存処理でラップされたリデューサー
 */
export function persistSession(
    name: string,
    reducer: Reducer,
    blacklist?: string[]
): Reducer {
  const config = {
    key: name,
    storage: sessionStorage,
    blacklist: blacklist || [],
  };
  const wrapper = logoutWrapper(reducer);
  return persistReducer(config, wrapper);
}

/**
 * ログアウト時に状態を初期化するラッパー
 *
 * @param reducer リデューサー
 * @returns {Reducer} ラップされたリデューサー
 */
export function logoutWrapper(reducer: Reducer): Reducer {
  return (state, action) => {
    if (action.type === 'DO_LOGOUT') {
      return reducer(undefined, action);
    }
    return reducer(state, action);
  };
}

// デフォルトエクスポート
const persist = {
  session: persistSession,
  local: persistLocal,
  none: logoutWrapper,
};
export default persist;
